/**
 * Vote/report API. Wire-shape matches the Go server in
 * `opensoi-backend/internal/reports/handlers.go` (`submitRequest`):
 *
 *   { stall_id, kind: "open" | "closed", gps: { lat, lng } }
 *
 * `accuracy_m` is NOT sent today (server does not accept it; Go's default
 * decoder silently drops unknown fields, but the field name has not been
 * negotiated). When the server grows an `Accuracy` field we'll add it here.
 */

import { apiFetch } from './client';

export interface VoteResponse {
  id: string;
  stall_id: string;
  kind: 'open' | 'closed';
  reported_at: string;
  expires_at: string;
  distance_to_pin_m: number;
  points_awarded: number;
}

export const reportsApi = {
  vote: (
    stall_id: string,
    kind: 'open' | 'closed',
    coords: { lat: number; lng: number },
    token: string,
    signal?: AbortSignal,
  ) =>
    apiFetch<VoteResponse>('/v1/reports', {
      method: 'POST',
      body: {
        stall_id,
        kind,
        gps: { lat: coords.lat, lng: coords.lng },
      },
      token,
      signal,
    }),
};
